export default __webpack_public_path__ + "static/emailright-80419d26d692161ffe08d27a881680ba.png";